import GetStartedFirst from '@Components/Common/GetStartedProductPage/GetStartedFirst'
import React, { useRef } from 'react'
import GetStartedThird from '@Components/Common/GetStartedProductPage/GetStartedThird'
import GetStartedFourth from '@Components/Common/GetStartedProductPage/GetStartedFourth'
import GetStartedSecond from '@Components/Common/GetStartedProductPage/GetStartedSecond'
import HomeSectionTwo from '@PagesComponent/Home/HomeSections/HomeSectionTwo'
import LandingUrlPageStyle from './landingUrlPage.style'
import IconSection from './IconSection'
import { LinkAnchor } from '@Components/Common/CommonMethods'
import HomeSectionFive from '@PagesComponent/Home/HomeSections/HomeSectionFive'

const index = (props) => {
    const myRef = useRef();

    function handleClick() {
        myRef?.current?.scrollIntoView({ behavior: "smooth" });
    };

    const LIST_TEXT = [
        "Healthy Body Mass Index (BMI) Report",
        "Heart Health Report",
        "Cognitive and Brain Function Report",
        "Detoxification Report",
        "Energy Report",
        "Gut/Microbiome Report",
        "Healthy Immune Response Report",
        "Healthy Inflammatory Response Report",
        "Methylation Report",
        "Mood Report"
    ];
    return (
        <>
            <LandingUrlPageStyle>
                <div className='icon-section-page'><IconSection handleClick={handleClick} myRef={myRef} /></div>
                <div className='home-section-new'><HomeSectionTwo {...props} /></div>
                <div className='first_content_section'><GetStartedFirst myRef={myRef} /></div>
                <div className="main-landing-wrap">
                    <div className='second_content_section right-img-wrap' id='dnatest'><GetStartedSecond list={LIST_TEXT} {...props} /></div>
                    <div className='Third_content_section' id='code_complex'><GetStartedThird {...props} /></div>
                    <div className='fourth_content_section'><HomeSectionFive {...props} /></div>
                </div>
            </LandingUrlPageStyle>
        </>
    )
}

export default index